import { ILbl } from "@/lbl/ILbl";
import Bus from "@/lib/Bus"
const bus: Bus = new Bus().getBus();
import { IOrder } from "./IOrder";
import { Order } from "./Order";

import {IAdresOdbiorcy, IOrderSvc, order_api} from "./IOrderSvc"
import { ISelector } from "../selector/ISelector"

export class OrderSvc implements IOrderSvc {
    
    
    async get_orders(selector: ISelector): Promise<IOrder[]> {
        const ret = await bus.api(order_api.get_orders, selector);
        if (!ret) return [];
        return ret;
    }
 
    public async start_flow_montaz(order: IOrder): Promise<IOrder | undefined>
    {
        const ret = await bus.api(order_api.start_flow_montaz, {order: order });
        if (ret) return (<IOrder> ret);
        else return undefined
    }


    public async create_order(lbls: ILbl[]): Promise<IOrder | undefined>
    {
        const ret = await bus.api(order_api.create_order, {lbls: lbls});
        if (ret) return (<IOrder> ret);
        else return undefined
    }

    public async update_order(order: IOrder): Promise<IOrder | undefined>
    {
        const ret = await bus.api(order_api.update_order, order);
        if (ret) return (<IOrder> ret);
        else return undefined
    }

    public async create_nowy_w_erp(order: IOrder): Promise<IOrder | undefined>
    {
        const ret = await bus.api(order_api.create_nowy_w_erp, order);
        if (ret) return (<IOrder> ret);
        else return undefined
    }

    public async get_adresy_odbiorcy(odbiorca_idn:string): Promise<IAdresOdbiorcy[]> 
    {
        const ret = await bus.call(order_api.get_adresy_odbiorcy, {odbiorca_idn: odbiorca_idn});
        return ret
    }


    public async find_by_id(_id: any): Promise<IOrder | undefined> {
        const ret = await bus.call(order_api.find_by_id,{_id:_id});
        if (ret && ret._id) return (<IOrder> ret);
        else return undefined
    }
    

}
      
  